import { render, staticRenderFns } from "./ShareContactModal.vue?vue&type=template&id=012ccbd7&scoped=true"
import script from "./ShareContactModal.vue?vue&type=script&lang=js"
export * from "./ShareContactModal.vue?vue&type=script&lang=js"
import style0 from "./ShareContactModal.vue?vue&type=style&index=0&id=012ccbd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012ccbd7",
  null
  
)

export default component.exports